"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

const simpleUniqueId = function(length = 6) {
  return Math.random().toString(36).substring(2, length + 2);
};

export { simpleUniqueId };
